import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4d83cbc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-support-cours-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Niveau "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Filière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Matière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nombre d'heures "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Auteur", -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Fichier principal (PDF) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_27 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Prérequis", -1))
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description", -1))
const _hoisted_34 = { class: "row mt-4" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "form-check" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fw-semibold",
  for: "estModulaire"
}, " Ce support est modulaire (divisé en plusieurs modules) ", -1))
const _hoisted_38 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = { class: "border border-primary mb-10" }
const _hoisted_41 = { class: "row d-flex align-items-center justify-content-between fw-bold py-3 bg-primary" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7 ps-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white mb-0" }, "Modules du support")
], -1))
const _hoisted_43 = { class: "col-md-5 pe-4" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-1" }, null, -1))
const _hoisted_45 = { class: "p-4" }
const _hoisted_46 = { class: "row mt-3 align-items-start" }
const _hoisted_47 = { class: "col-md-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Code module "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Titre du module "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_51 = { class: "col-md-4" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Fichier du module (PDF) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_53 = ["onChange"]
const _hoisted_54 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_55 = { class: "col-md-1 d-flex align-items-start pt-4" }
const _hoisted_56 = ["onClick", "disabled"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete" }, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "row mt-3" }
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Description du module", -1))
const _hoisted_62 = {
  key: 0,
  class: "my-4"
}
const _hoisted_63 = { class: "row mt-5" }
const _hoisted_64 = { class: "col-md-12" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "supportForm",
        onSubmit: _ctx.addSupportCours,
        onInvalidSubmit: _ctx.handleInvalidSubmit,
        "validation-schema": _ctx.supportSchema,
        validateOnInput: false,
        validateOnMount: false,
        initialValues: {
          nombreHeures: '',
          prerequis: '',
          description: '',
          titre: '',
          auteur: '',
          fichier: null,
          niveau: null,
          filiere: null,
          matiere: null,
          estModulaire: false,
          modulesAdded: []
        }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  name: "titre",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Titre du support"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "titre",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, { name: "niveau" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.niveauxOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onNiveauChange,
                      placeholder: "Sélectionner le niveau",
                      disabled: _ctx.isLoadingAssignments
                    }), null, 16, ["options", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "niveau",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, { name: "filiere" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.filieresOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onFiliereChange,
                      placeholder: "Sélectionner la filière",
                      disabled: !_ctx.selectedNiveau || _ctx.isLoadingFilieres
                    }), null, 16, ["options", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "filiere",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, { name: "matiere" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.matieresOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      placeholder: "Sélectionner la matière",
                      disabled: !_ctx.selectedNiveau || !_ctx.selectedFiliere || _ctx.isLoadingMatieres
                    }), null, 16, ["options", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "matiere",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, {
                  name: "nombreHeures",
                  type: "number",
                  min: "1",
                  max: "1000",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Ex: 60"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "nombreHeures",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Field, {
                  name: "auteur",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Nom de l'auteur (facultatif)"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "auteur",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_Field, {
                  name: "fichier",
                  type: "file",
                  accept: "application/pdf",
                  onChange: _ctx.onFichierChange,
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["onChange"]),
                _createVNode(_component_ErrorMessage, {
                  name: "fichier",
                  class: "text-danger"
                }),
                (_ctx.fichierName)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.fichierName), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_Field, {
                  name: "prerequis",
                  as: "textarea",
                  rows: "4",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Connaissances requises pour ce cours..."
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "prerequis",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_Field, {
                  name: "description",
                  as: "textarea",
                  rows: "4",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Description détaillée du support de cours..."
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "description",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_Field, {
                  name: "estModulaire",
                  type: "checkbox"
                }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "checkbox",
                      id: "estModulaire",
                      class: "form-check-input",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onEstModulaireChange && _ctx.onEstModulaireChange(...args)))
                    }), null, 16)
                  ]),
                  _: 1
                }),
                _hoisted_37
              ])
            ])
          ]),
          (_ctx.estModulaire)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("button", {
                          class: "btn btn-success float-end",
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewModule && _ctx.addNewModule(...args)))
                        }, [
                          _hoisted_44,
                          _createTextVNode(" Ajouter un module ")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedModules, (module, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: module.tempId
                        }, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${index}].code`
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                    type: "text",
                                    class: "form-control shadow-none",
                                    placeholder: "Ex: MOD-001",
                                    maxlength: "50"
                                  }), null, 16)
                                ]),
                                _: 2
                              }, 1032, ["name"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `modulesAdded[${index}].code`,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _hoisted_50,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${index}].titre`
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                    type: "text",
                                    class: "form-control shadow-none",
                                    placeholder: "Titre du module"
                                  }), null, 16)
                                ]),
                                _: 2
                              }, 1032, ["name"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `modulesAdded[${index}].titre`,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _hoisted_52,
                              _createElementVNode("input", {
                                type: "file",
                                accept: "application/pdf",
                                onChange: (e) => _ctx.onModuleFichierChange(index, e),
                                class: "form-control shadow-none"
                              }, null, 40, _hoisted_53),
                              (module.fichierName)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_54, _toDisplayString(module.fichierName), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-sm",
                                onClick: ($event: any) => (_ctx.removeModule(index)),
                                disabled: _ctx.addedModules.length === 1
                              }, _hoisted_58, 8, _hoisted_56)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _hoisted_61,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${index}].description`
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createElementVNode("textarea", _mergeProps({ ref_for: true }, field, {
                                    class: "form-control shadow-none",
                                    rows: "3",
                                    placeholder: "Description optionnelle du module..."
                                  }), null, 16)
                                ]),
                                _: 2
                              }, 1032, ["name"])
                            ])
                          ]),
                          (index < _ctx.addedModules.length - 1)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_62))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_67))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Création en cours...' : 'Créer le support de cours'), 1)
                ], 8, _hoisted_66),
                _createVNode(_component_router_link, {
                  to: "/liste-support",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_68,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onInvalidSubmit", "validation-schema"])
    ])
  ]))
}